import type { Expect, Equal } from "pb.types";
import z from "zod";

// Concept of plain typedoc-able simple types for API Reference Docs etc.
// Unfortunately requires type duplication.
// But is strictly enforced to make sure they never get out of sync.

////////////////////////////////////////////////////////////////////////////////

export type AppSyncKeepAlive = { type: "ka" };
export const AppSyncKeepAlive = z.object({ type: z.literal("ka") });
// prettier-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
(!0 as Expect<Equal<AppSyncKeepAlive, z.infer<typeof AppSyncKeepAlive>>>);

////////////////////////////////////////////////////////////////////////////////

export type AppSyncConnectionInit = { type: "connection_init" };
export const AppSyncConnectionInit = z.object({
	type: z.literal("connection_init"),
});
// prettier-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
(!0 as Expect<Equal<AppSyncConnectionInit, z.infer<typeof AppSyncConnectionInit>>>);

////////////////////////////////////////////////////////////////////////////////

export type AppSyncConnectionAck = { type: "connection_ack" };
export const AppSyncConnectionAck = z.object({
	type: z.literal("connection_ack"),
});
// prettier-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
(!0 as Expect<Equal<AppSyncConnectionAck, z.infer<typeof AppSyncConnectionAck>>>);

////////////////////////////////////////////////////////////////////////////////

export type AppSyncStart = {
	type: "start";
	id: string;
	payload: {
		data: string; // JSON.stringify({ query: string, variables: { ... } })
		extensions: {
			authorization: {
				Authorization: string; // Access Token (as-is, no `Bearer`/prefixes)
				host: string; // Without protocol or path (`/graphql/realtime` etc.)
			};
		};
	};
};
export const AppSyncStart = z.object({
	type: z.literal("start"),
	id: z.string(),
	payload: z.object({
		data: z.string(),
		extensions: z.object({
			authorization: z.object({
				Authorization: z.string(),
				host: z.string(),
			}),
		}),
	}),
});
// prettier-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
(!0 as Expect<Equal<AppSyncStart, z.infer<typeof AppSyncStart>>>);

////////////////////////////////////////////////////////////////////////////////

export type AppSyncStartAck = { type: "start_ack"; id: string };
export const AppSyncStartAck = z.object({
	type: z.literal("start_ack"),
	id: z.string(),
});
// prettier-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
(!0 as Expect<Equal<AppSyncStartAck, z.infer<typeof AppSyncStartAck>>>);

////////////////////////////////////////////////////////////////////////////////

export type AppSyncStartError = {
	type: "error";
	id: string;
	payload: {
		errors: Array<{ message: string }>;
	};
};
export const AppSyncStartError = z.object({
	type: z.literal("error"),
	id: z.string(),
	payload: z.object({
		errors: z.array(z.object({ message: z.string() })),
	}),
});
// prettier-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
(!0 as Expect<Equal<AppSyncStartError, z.infer<typeof AppSyncStartError>>>);

////////////////////////////////////////////////////////////////////////////////

export type AppSyncData = {
	type: "data";
	id: string;
	payload: {
		data?: unknown; // Matches the ResultOf<TypedDocumentNode>.
	};
};
export const AppSyncData = z.object({
	type: z.literal("data"),
	id: z.string(),
	payload: z.object({
		data: z.unknown(),
	}),
});
// prettier-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
(!0 as Expect<Equal<AppSyncData, z.infer<typeof AppSyncData>>>);
